
/**
 * Get the authentication token for a user given an
 * app state.
 *
 * @param {Object} state The state of the application.
 */
export default function(state) {
  if (!state.session.token) { return null };
  return state.session.token;
};



// WEBPACK FOOTER //
// ./src/utils/get-auth.js